"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PopoverLegacy = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var close_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/close.icon.svg"));
var classMappers_1 = require("./classMappers");
var Popover_module_scss_1 = __importDefault(require("./Popover.module.scss"));
/**
 * Used for the legacy popover only. For the new popover, the position of the
 * arrow is determined by popper.
 */
var mapArrowPositionToClass = function (position) {
    switch (position) {
        case "start":
            return Popover_module_scss_1["default"].arrowPositionStart;
        case "end":
            return Popover_module_scss_1["default"].arrowPositionEnd;
        case "center":
            return Popover_module_scss_1["default"].arrowPositionCenter;
        default:
            return "";
    }
};
/**
 * Used for the legacy popover only.
 * In the legacy popover, the "side" described the location of the arrow.
 * In the modern popover, the "side" describes the location of the popover
 * relative to the reference element.
 */
var mapArrowSideToClass = function (side) {
    switch (side) {
        case "top":
            return Popover_module_scss_1["default"].arrowSideTop;
        default:
            return Popover_module_scss_1["default"].arrowSideBottom;
    }
};
/**
 * Please use `usePopover` or `Popover` instead
 * @deprecated
 */
exports.PopoverLegacy = react_1["default"].forwardRef(function (_a, ref) {
    var automationId = _a.automationId, children = _a.children, _b = _a.variant, variant = _b === void 0 ? "default" : _b, _c = _a.side, side = _c === void 0 ? "bottom" : _c, _d = _a.size, size = _d === void 0 ? "small" : _d, _e = _a.position, position = _e === void 0 ? "center" : _e, heading = _a.heading, _f = _a.dismissible, dismissible = _f === void 0 ? false : _f, onClose = _a.onClose, _g = _a.singleLine, singleLine = _g === void 0 ? false : _g, customIcon = _a.customIcon;
    return (react_1["default"].createElement("div", { className: (0, classnames_1["default"])(Popover_module_scss_1["default"].root, (0, classMappers_1.mapSizeToClass)(size)), style: { transform: "translateX(-50%)" }, ref: ref, "data-automation-id": automationId },
        react_1["default"].createElement("div", { className: (0, classMappers_1.mapVariantToBoxClass)(variant) },
            heading && (react_1["default"].createElement("div", { className: Popover_module_scss_1["default"].header },
                variant !== "default" && (react_1["default"].createElement("span", { className: (0, classnames_1["default"])(Popover_module_scss_1["default"].icon, (0, classMappers_1.mapVariantToIconClass)(variant)) },
                    react_1["default"].createElement(component_library_1.Icon, { role: "presentation", icon: customIcon ? customIcon : (0, classMappers_1.mapVariantToIcon)(variant) }))),
                react_1["default"].createElement("div", { className: Popover_module_scss_1["default"].singleLine }, heading),
                dismissible && (react_1["default"].createElement("button", { type: "button", className: Popover_module_scss_1["default"].close, onClick: onClose },
                    react_1["default"].createElement(component_library_1.Icon, { role: "presentation", icon: close_icon_svg_1["default"] }))))),
            react_1["default"].createElement("div", { className: (0, classnames_1["default"])(Popover_module_scss_1["default"].container, (0, classMappers_1.mapLineVariant)(singleLine)) }, children)),
        react_1["default"].createElement("div", { className: (0, classnames_1["default"])(Popover_module_scss_1["default"].arrowWrapper, mapArrowSideToClass(side), mapArrowPositionToClass(position)) },
            react_1["default"].createElement("div", { className: (0, classnames_1["default"])(Popover_module_scss_1["default"].arrow, (0, classMappers_1.mapArrowVariantToClass)(variant)) }))));
});
exports.PopoverLegacy.displayName = "PopoverLegacy";
//# sourceMappingURL=PopoverLegacy.js.map